import style from './PageTitle.module.scss';

function PageTitle(props){
    return(
        <h1 className={style.PageTitle}>{props.children}</h1>
    )
}

export default PageTitle